/**
 * created by li si yi
 * 首次登录修改密码
 */
import React, {Component} from 'react';
import {Modal, Button, message} from "antd";
import BaseComponent from "../../../base/BaseComponent";
import AmendPassword from "../../../components/amendPassword/AmendPassword";

export default class ChangePassword extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            deptList: [],
            currentClick: {},
            // level: "2",// 密码强度等级
        };
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                {this.renderModal()}
            </div>
        )
    }

    // 弹框
    renderModal = () => {
        // let {} = this.state;
        return (
            <div style={{display: 'flex'}}>
                <AmendPassword
                    ref={ref => this.AmendPassword = ref}
                    isShowFirstLogin={true}
                    updatePasswordCall={(data) => {
                        console.log('1111111111111111', data);
                        this.updatePassword(data);
                    }}
                    handleCancel={() => {
                        this.handleCancel()
                    }}/>
            </div>
        )
    };
    // 显示
    showModal = (userId, key, allData) => {
        // this.getPasswordLevel((res) => {
        //     this.state.level = res;
            this.state.userId = userId;
            this.state.key = key;
            this.setState({}, () => {
                this.allData = allData;
                this.AmendPassword.show(allData);
            });
        // });
    };
    // getPasswordLevel = (call) => {
    //     this.request({
    //         url: '/cm-sites-sys/user/getCurrentLevel',
    //         callBack: (res) => {
    //             if (res) {
    //                 call && call(res)
    //             }
    //         }
    //     })
    // };
    // 确定修改密码
    updatePassword = (data) => {
        let body = {
            userId: this.state.userId,
            tokenKey: this.state.key,
            oldPass: data.pass,
            newPass: data.pass2,
            publicKey: data.publicKey,
        };
        this.request({
            url: "/cm-sites-sys/login/updatePwd",
            body: body,
            method: 'post',
            contentType: 'form-data',
            haveToken: false,
            callBack: (res) => {
                console.log("修改密码接口===============", res);
                if (res) {
                    message.success("密码修改成功，请重新登录", 1, () => {
                        window.location.reload();
                    })
                }
                // console.log(res)
                // if (res && res.data) {
                //     this.callback && this.callback(res.data)
                // }
            }
        })
    };
    // 取消
    handleCancel = () => {
        // 刷新验证码
        this.props.refreshCode && this.props.refreshCode();
    };
};